export default __webpack_public_path__ + "wasm/movement_wasm.wasm";